import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./home";
import Membership from "./membership";
import About from "./about";
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </div>
  );
}

export default App;
